import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

// use video orverlay + custom style for CTA
import VideoOverlay from '../../../Core/VideoOverlay';
import Hubspot from '../../Admin/Hubspot';

import { TitleWrapper, Wrapper, LinkWrapper } from './styles';

function VideoPlayerWithCTA({ data }) {
  if (!data) return null;
  const {
    titleHtml,
    subtitleHtml,
    image,
    imageSharp,
    formId,
    bannerCTA,
    ctaType,
    ariaLabel,
    queryString,
    bannerCTAText,
    lang,
  } = data;
  return (
    <Wrapper id="video-player-cta">
      <VideoOverlay
        thumbnail={imageSharp ? imageSharp.publicURL : image.url}
        className="video-with-cta-overlay"
      >
        <TitleWrapper>
          {ReactHtmlParser(titleHtml)}
          {ReactHtmlParser(subtitleHtml)}
          {/* CTA with link wrapper containing proper margins */}
          {formId ? (
            <Hubspot
              uuid={formId}
              data={bannerCTAText}
              className={`${ctaType} auto-size`}
            />
          ) : (
            <LinkWrapper
              className={`${ctaType} auto-size`}
              to={bannerCTA.url}
              ariaLabel={ariaLabel}
              queryString={queryString}
              lang={lang}
            >
              {bannerCTAText}
            </LinkWrapper>
          )}
        </TitleWrapper>
      </VideoOverlay>
    </Wrapper>
  );
}

VideoPlayerWithCTA.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default VideoPlayerWithCTA;
